import {setAccessToken, setRefreshToken} from 'utils/cookies';
import {LoginResponseBody} from './types';

export const saveTokens = (tokens: LoginResponseBody) => {
  // Set access token if it exists
  if (tokens.access_token && tokens.expires_in) {
    setAccessToken(tokens.access_token, parseInt(tokens.expires_in));
  }

  // Set refresh token if it exists
  if (tokens.refresh_token) {
    setRefreshToken(tokens.refresh_token);
  }
};
